<section class="file-upload-container">
  <form [formGroup]="soaUploadForm">
    <input
      mat-raised-button
      color="primary"
      (change)="pdfInputChange($event)"
      accept="application/pdf"
      type="file"
      id="soaInputLabel"
      formControlName="fileUploader"
      [attr.aria-placeholder]="'Upload File'"
    />
  </form>
</section>
